module.exports = __webpack_public_path__ + "edfda8749fb0f22d8ccc585d16018c29.csv";